import React, { useState } from 'react'

const DataContext = React.createContext(null)

export { DataContext }

function DataContextContainer(props) {
  const locale = localStorage.getItem('locale')

  const [lang, setLang] = useState(locale || 'en')
  const [authUser, setAuthUser] = useState(null)
  const [loginError, setLoginError] = useState('')
  const [loggedInUser, setLoggedInUser] = useState(null) // Amplify vs internal user. TODO: Reconcile these 2.
  const [isCheckingLogin, setIsCheckingLogin] = useState(true)
  const [promptRolesModalConfig, setPromptRolesModalConfig] = useState({})

  return (
    <DataContext.Provider
      value={{
        lang,
        setLang,
        // Can't have both authUser and loggedInUser. TODO: Reconcile these 2.
        authUser,
        setAuthUser,
        loggedInUser,
        setLoggedInUser,
        isCheckingLogin,
        setIsCheckingLogin,
        promptRolesModalConfig,
        setPromptRolesModalConfig,
        loginError,
        setLoginError,
      }}
    >
      {props.children}
    </DataContext.Provider>
  )
}
export default DataContextContainer
